// Preact
// eslint-disable-next-line no-unused-vars
import { Fragment, h } from 'preact';
import { useContext, useEffect, useRef } from 'preact/hooks';
import PropTypes from 'prop-types';
import { SearchContext } from '../contexts/Search';

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
const User = ( props ) => {
	const { state } = useContext( SearchContext );
	const { loading, focusNewUser, focusUserId } = state;
	const { user } = props;
	const { data } = user;
	const { ID } = data;
	const ref = useRef( null );

	useEffect( () => {
		if ( focusUserId === ID && focusNewUser && !loading ) {
			ref.current.querySelector( 'a' ).focus();
		}
	}, [loading, focusNewUser, focusUserId, ID] );

	// eslint-disable-next-line react/no-danger
	return <div className="border-top py-4" ref={ref} dangerouslySetInnerHTML={{ __html: user.markup }} />;
};

User.propTypes = {
	user: PropTypes.shape( {
		data: PropTypes.shape( {
			ID: PropTypes.number.isRequired,
		} ),
		markup: PropTypes.string.isRequired,
	} ).isRequired,
};

export default User;
